import React from 'react';
import I18n from '@utils/i18n';
import { Text } from '@ui';
import './QbLinkDetailsStyles.scss';
function QbLinkDetails({ qbLink }) {
    const { id, url, lastSyncedOn } = qbLink;
    return (React.createElement("div", { className: "pc-edit__qb-link mb-3", "data-testid": "qb-link-details" },
        React.createElement("div", { className: "pc-edit__qb-link-label" },
            React.createElement("img", { height: "16", width: "16", src: "/qbo.svg", className: "custom-icon--qbo", alt: "", title: I18n.t('proposed_corrections.edit.qb_link.title') }),
            React.createElement(Text, { variant: "label" }, I18n.t('proposed_corrections.edit.qb_link.id_label'))),
        React.createElement("div", { className: "pc-edit__qb-link-value" },
            url ? (React.createElement(Text, { variant: "link", as: "a", href: url, target: "_blank", rel: "noopener noreferrer", title: I18n.t('proposed_corrections.edit.qb_link.open_in_quickbooks'), className: "pc-edit__qb-link-anchor" },
                id,
                " ",
                React.createElement("i", { className: "fa-light fa-arrow-up-right-from-square", "aria-hidden": "true" }))) : (React.createElement(Text, { variant: "body", className: "pc-edit__qb-link-id" }, id)),
            lastSyncedOn && (React.createElement(Text, { variant: "xx-small", as: "span", className: "pc-edit__qb-link-synced" }, I18n.t('proposed_corrections.edit.qb_link.last_synced', { date: lastSyncedOn }))))));
}
export default QbLinkDetails;
